module.exports = __webpack_public_path__ + "static/media/transform_icon.4f276d0d.svg";